import { queryeStudentWeekCourse } from '@/api'
export default {
  components: {},
  props: [],
  name: 'personalProjectList-page',
  data () {
    return {
      weekPrejectList: [],
      courseInfo: null
    }
  },
  created () {
    this.getProjectList()
  },
  methods: {
    async getProjectList () {
      const { data } = await queryeStudentWeekCourse({ sellOrderId: this.$route.query.sellOrderId, classId: this.$route.query.classId })
      this.weekPrejectList = data.weekStrList
      this.courseInfo = data.courseInfo
    },
    goProjectDetail (item) {
      // 普通反馈
      if (this.courseInfo.classType === 1) {
        this.$router.push({ path: '/projectDetails', query: { sellOrderId: this.courseInfo.sellOrderId, classId: item.classId, weekStr: item.weekStr, isCurrentClass: item.isCurrentClass, createStr: item.createStr, courseType: this.courseInfo.courseType } })
      } else {
        // 论文反馈新
        if (Number(this.courseInfo.templateType) === 3) {
          this.$router.push({ path: '/planB/paperDetail', query: { sellOrderId: this.courseInfo.sellOrderId, classId: item.classId, weekStr: item.weekStr } })
        } else {
          this.$router.push({ path: '/paperDetail', query: { sellOrderId: this.courseInfo.sellOrderId, classId: item.classId, weekStr: item.weekStr } })
        }
      }
    }
  }
}
